/**
 * Route notification taps into the app's router (Card 15).
 *
 * `pushNotificationActionPerformed` fires for background AND killed-state taps, and in
 * the killed case it fires while the app is still booting — before React mounts and long
 * before a router exists. `pushNotifications.ts` therefore parks the destination and this
 * hook hands it the router as soon as one is available, flushing anything queued.
 *
 * Navigating through the router rather than assigning `window.location.href` matters on
 * native: a bundled build serves the SPA from the local asset server, so a location
 * assignment is a full document reload that throws away the in-memory session and
 * re-runs startup. Mounted once, in App.tsx. No-op on web, where nothing ever queues.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setPushNavigationHandler } from '@/services/capacitor/pushNotifications';

export function usePushNavigation(): void {
  const navigate = useNavigate();

  useEffect(() => {
    return setPushNavigationHandler((path) => {
      console.log('[Push] Navigating to tap-through destination:', path);
      navigate(path);
    });
  }, [navigate]);
}
